import { type ReactElement } from 'react';
import { sgwtConnect } from '@/sgwt/sgwtConnect.ts';
import { ApplicationDetails } from '@/components/application/applicationDetails.tsx';

export function ApplicationDetailsPage(): ReactElement {

  if (sgwtConnect.isAuthorized())
    return <ApplicationDetails />;
}